var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.254
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.623-.001l8.054 6.923a.485.485 0 00.6 0l8.054-6.923H.623zM0 .668v11.585h18V.668L9.415 7.937a.7.7 0 01-.877 0z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/email_full.b86f41d1652a8e4042f53f59000d2c7a.svg";
export { SvgEmailFull as ReactComponent };